module.exports = __webpack_public_path__ + "static/media/1080p.576500d3.mp4";